// @flow

import type { RequestStates } from 'types/redux';
import _ from 'lodash';

export const requestStateInitial: RequestStates = {
  isPending: false,
  isFailure: false,
  isSuccessful: false,
};

export const requestStatePending: RequestStates = {
  isPending: true,
  isFailure: false,
  isSuccessful: false,
};

export const requestStateFailure: RequestStates = {
  isPending: false,
  isFailure: true,
  isSuccessful: false,
};

export const requestStateSuccessful: RequestStates = {
  isPending: false,
  isFailure: false,
  isSuccessful: true,
};

export function isRequestsPending(...requestStates: Array<RequestStates>): boolean {
  return _.some(requestStates, 'isPending');
}

export function isRequestsSuccessful(...requestStates: Array<RequestStates>): boolean {
  return _.every(requestStates, 'isSuccessful');
}

export function hasJustSuccess(olderRequest: RequestStates, newerRequest: RequestStates) {
  return olderRequest.isPending && newerRequest.isSuccessful;
}

export function hasJustFail(olderRequest: RequestStates, newerRequest: RequestStates) {
  return olderRequest.isPending && newerRequest.isFailure;
}
